var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96397 30.3729L11.5936 16.6597H27.4167L29.0463 30.3729H9.96397ZM19.5051 9.62714C21.9308 9.62714 23.9058 11.6022 23.9058 14.0312H15.1044C15.1044 11.6022 17.0795 9.62714 19.5051 9.62714ZM29.7522 14.0312H26.5343C26.5343 10.1491 23.3877 6.99872 19.5051 6.99872C15.6226 6.99872 12.476 10.1491 12.476 14.0312H9.25806L7.00513 33.0013H32.0051L29.7522 14.0312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.3aa57eee1687af6a0d1eb2bfad95cb8e.svg";
export { ForwardRef as ReactComponent };